export function axIsInstanceOfInterface(x) {
    return false;
}
